import { globalCss } from 'stitches.config';

const globalStyles = globalCss({
  '@font-face': [
    {
      fontFamily: 'Telegraf',
      src: "url('/fonts/PPTelegraf-Regular.woff2') format('woff2')",
      fontWeight: '400',
      fontStyle: 'normal',
      fontDisplay: 'swap',
    },
    {
      fontFamily: 'Telegraf',
      src: "url('/fonts/PPTelegraf-Bold.woff2') format('woff2')",
      fontWeight: '700',
      fontStyle: 'normal',
      fontDisplay: 'swap',
    },
    {
      fontFamily: 'Neue Montreal',
      src: "url('/fonts/PPNeueMontreal-Regular.woff2') format('woff2')",
      fontStyle: 'normal',
      fontWeight: '400',
      fontDisplay: 'swap',
    },
    {
      fontFamily: 'Neue Montreal',
      src: "url('/fonts/PPNeueMontreal-Medium.woff2') format('woff2')",
      fontStyle: 'normal',
      fontWeight: '500',
      fontDisplay: 'swap',
    },
    {
      fontFamily: 'Neue Montreal',
      src: "url('/fonts/PPNeueMontreal-Bold.woff2') format('woff2')",
      fontStyle: 'normal',
      fontWeight: '600',
      fontDisplay: 'swap',
    },
  ],
});

export default globalStyles;
